import { Button, Box, Typography } from '@mui/material';
import TableOfCheckins from '@/components/TableOfCheckins';
import { UnreviewedCheckinsByTeams } from '@/services/unreviewedCheckins';
import { CheckinSummary } from '@/types/api';
import styles from './UnreviewedCheckinsByTeams.styles';
import RemindPeopleToCheckInButton from '../RemindPeopleToCheckInButton';

export type UnreviewedCheckinsByTeamsProps = {
  checkinsByTeamsList: UnreviewedCheckinsByTeams[];
  handleStartReviewingCheckins: (groupOfCheckins: CheckinSummary[]) => void;
  handleNotifyTeam: (id: string) => void;
};

const UnreviewedCheckinsByTeamsComponent = function ({
  handleStartReviewingCheckins,
  checkinsByTeamsList,
  handleNotifyTeam,
}: UnreviewedCheckinsByTeamsProps): JSX.Element {
  return (
    <Box>
      {!checkinsByTeamsList.length && <TableOfCheckins checkins={[]} />}
      {checkinsByTeamsList.map((checkinsByTeam) => {
        const pendingCheckinsByTeams = checkinsByTeam.usersToNotify;
        const hasAnsweredCheckinsToBeReviewed = checkinsByTeam.checkins.some(
          (checkin) => checkin.answeredAt
        );

        return (
          <div key={checkinsByTeam.teamId}>
            <Box sx={styles.box}>
              <Typography fontSize={25} fontWeight={600} color="primary">
                {checkinsByTeam.name}
              </Typography>

              <div>
                {!!pendingCheckinsByTeams && (
                  <RemindPeopleToCheckInButton
                    amountOfUsersToNotify={pendingCheckinsByTeams}
                    handleNotifyUsers={() => handleNotifyTeam(checkinsByTeam.teamId)}
                  />
                )}
                {hasAnsweredCheckinsToBeReviewed && (
                  <Button
                    onClick={() => handleStartReviewingCheckins(checkinsByTeam.checkins)}
                    variant="contained"
                  >
                    Start reviewing
                  </Button>
                )}
              </div>
            </Box>
            <TableOfCheckins checkins={checkinsByTeam.checkins} />
          </div>
        );
      })}
    </Box>
  );
};

export default UnreviewedCheckinsByTeamsComponent;
